<template>
  <div>
    <v-card flat class="mt-2">
      <v-form class="multi-col-validation">
        <v-card-title>Register Lanjutan Pembimbing Klinik</v-card-title>
        <v-card-text class="">
          <v-row>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.username" label="Username :" dense outlined readonly></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.email" label="Email :" dense outlined readonly></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.nama" label="Nama :" dense outlined></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.nip" label="NIP/NRB :" dense outlined></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field
                v-model="userSelected.masa_kerja"
                label="Masa Kerja (Tahun) :"
                dense
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-text-field v-model="userSelected.alamat" label="Alamat :" dense outlined></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="userSelected.no_hp" label="No Handphone :" dense outlined></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-autocomplete
                v-model="userSelected.id_dokdiknis"
                :items="dokdiknis"
                outlined
                dense
                label="Dokdiknis/Pembimbing :"
                item-text="nama"
                item-value="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <h3 class="ml-2 mt-2">Upload Dokumen :</h3>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">No</th>
                  <th class="text-left">Nama</th>
                  <th class="text-left">File</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dokumens" v-bind:key="item.id">
                  <td>{{ parseInt(index) + 1 }}</td>
                  <td>{{ item.nama }}</td>
                  <td>
                    <uploaded-dokumen-registrasi :namaDokumen="item.kode"></uploaded-dokumen-registrasi>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-form>
      <v-card-text>
        <v-data-table
          :headers="table.headers"
          :items="table.items"
          :options.sync="tableOptions"
          :server-items-length="table.totalItems"
          :loading="table.loading"
          dense
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <h3 class="">Pengembangan Diri :</h3>
              </v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:item.tanggal="{ item }">
            {{ formatDate(item.tanggal) }}
          </template>
          <template v-slot:item.sertifikat="{ item }">
            <a :href="item.file_url" target="_blank">Lihat File</a>
          </template>
          <template v-slot:no-data>
            <v-btn x-small color="primary" @click="getDataFromApi()"> Reload </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import UploadedDokumenRegistrasi from '@/components/upload/UploadedDokumenRegistrasi.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
  components: {
    UploadedDokumenRegistrasi,
  },
  data: () => ({
    userTambahan: {
      // username: '',
      // email: '',
      // nama: '',
      // nip: '',
      // masa_kerja: '',
      // alamat: '',
      // no_hp: '',
      // dokdiknis: '',
      dokumen: [],
    },
    dokumens: [],
    dokdiknis: [],
    tableOptions: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
    table: {
      loading: true,
      headers: [
        { text: 'No', align: 'start', sortable: false, value: 'no' },
        { text: 'Nama', value: 'nama', sortable: false },
        { text: 'NIP', value: 'nip', sortable: false },
        { text: 'Masa Kerja', value: 'masa_kerja', sortable: false },
        { text: 'Pelatihan/Seminar/Workshop', value: 'ijazah', sortable: false },
        { text: 'Nomor Sertifikat', value: 'sip', sortable: false },
        { text: 'Tanggal Pelatihan', value: 'tanggal', sortable: false },
        { text: 'Sertifikat', value: 'sertifikat', sortable: false },
      ],
      items: [],
      totalItems: 0,
    },
  }),
  computed: {
    headers() {
      return {
        Authorization: this.$store.state.token,
      }
    },
    userSelected() {
      return this.$store.getters.userSelected
    },
  },
  watch: {
    userSelected: function () {
      this.getDokumenRequirement()
      this.getInstitusiPendidikan()
      this.getPilihanDokdiknis()
      this.getDataFromApi()
    },
  },
  created() {
    this.getDokumenRequirement()
    this.getInstitusiPendidikan()
    this.getPilihanDokdiknis()
      this.getDataFromApi()
  },
  methods: {
    getDataFromApi() {
      const pembimbing_id = this.$store.getters.userSelected.id
      const { page, itemsPerPage } = this.tableOptions
      const fmData = new FormData()
      fmData.append('page', page)
      fmData.append('itemsPerPage', itemsPerPage)
      fmData.append('search', '')
      fmData.append('pembimbing_id', pembimbing_id)
      axiosPostAuth('api/Pembimbing/getPengembanganPembimbing_datatable', fmData)
        .then(response => {
          this.table.items = response.data
          this.table.totalItems = response.total
          this.table.loading = false
        })
        .catch(error => {
          alert(error)
        })
    },
    getDokumenRequirement() {
      let fmData = new FormData()
      fmData.append('profesi', 'Pembimbing')
      axiosPostAuth('api/RegisterLanjutan/getDokumenRequirement', fmData).then(response => {
        this.dokumens = Object.assign({}, response.data)
      })
    },
    getInstitusiPendidikan() {
      const headers = this.headers
      axios
        .get(`${apiRoot}/api/RegisterLanjutan/getInstitusiPendidikans`, { headers })
        .then(response => {
          if (response.data.code === 200) {
            this.institusi_pendidikans = response.data.datas
          } else {
            alert(response.data.message)
          }
        })
        .catch(error => {
          alert(error)
        })
    },
    getPilihanDokdiknis() {
      // this.loading = true
      const headers = this.headers
      axios
        .get(`${apiRoot}/api/RegisterLanjutan/getPilihanDokdiknis`, { headers })
        .then(response => {
          if (response.data.code === 200) {
            this.dokdiknis = response.data.datas
          } else {
            alert(response.data.message)
          }
        })
        .catch(error => {
          alert(error)
        })
    },
    simpan() {
      const headers = this.headers
      const fmData = new FormData()
      fmData.append('username', this.userTambahan.username)
      fmData.append('email', this.userTambahan.email)
      fmData.append('nama', this.userTambahan.nama)
      fmData.append('nip', this.userTambahan.nip)
      fmData.append('masa_kerja', this.userTambahan.masa_kerja)
      fmData.append('alamat', this.userTambahan.alamat)
      fmData.append('no_hp', this.userTambahan.no_hp)
      fmData.append('dokdiknis', this.userTambahan.dokdiknis)
      const dokumen = []
      this.userTambahan.dokumen.forEach(element => {
        dokumen.push(element.id)
      })
      fmData.append('dokumen', dokumen)
      fmData.append('role_temp', this.userSelected.role_temp)
      axios
        .post(`${apiRoot}/api/RegisterLanjutan/addRegistrasiPembimbing`, fmData, { headers })
        .then(response => {
          if (response.data.code === 200) {
            this.$store.dispatch('logout', response.data.message)
          } else {
            alert(response.data.message)
          }
        })
        .catch(error => {
          alert(error)
        })
    },
  },
}
</script>